import {CtPage} from './ct-page';
import {LocaleHint} from './locale-hint';
import {CtLocaleKey} from './ct-locale-key';

import {construct, createInstance, ModelProperties} from '../utils';

export class CtLocaleKeyHints {
    id!: number;

    keyId!: number;

    hintId!: number;

    pageId?: number | null;

    key?: CtLocaleKey;

    hint?: LocaleHint;

    page?: CtPage;

    constructor(keyHint?: ModelProperties<CtLocaleKeyHints>) {
        if (keyHint) {
            construct(this, keyHint);
            this.page = createInstance(CtPage, keyHint.page);
            this.hint = createInstance(LocaleHint, keyHint.hint);
        }
    }
}